<template>
  <div class="specialAttention">
    <div class="head">
      <div class="bodyTitle">
        <div class="pageTitle">{{ pageTitle }}</div>
      </div>
    </div>
    <div class="main">
      <div class="cilre">
        <div @click="pauseOrPlay()" class="eventBtn" v-show="true">
          <div class="stop" id="eventBtn"></div>
        </div>
      </div>
      <ul class="news" id="news">
        <li
          :data-topic_id="index"
          :key="index"
          @click="showDialog(item)"
          class="newslist animated fadeInDown"
          v-for="(item, index) in active_data"
        >
          <div class="news-box">
            <div class="r info">
              {{ item.newsTime.slice(0, 10) | temp_filter }}
            </div>
            <div class="r info">
              {{ item.title | temp_filter }}
            </div>
            <h5  @click="goind(item)" >{{ item.title | temp_filter }}</h5>
            <p @click="goind(item)" class="textp">{{item.content}}</p>
          </div>
        </li>
      </ul>
    </div>
      <el-dialog
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
   <div class="body_tiele">{{this.list.title}} <img class="body_img" @click="goindr(list.url)" src="@/assets/lian.png" alt=""> </div>
    <div class="live">{{this.list.source }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.list.newsTime|formatDate}}<div></div></div>
    <div  class="body_cont">{{this.list.content }}
        <div class="time_img" >
        <div class="wx_img" v-for="(item,index) in imgs" :key="index">
        <img v-if="item.imgUrl!=''" class="img_wx" :src="item.imgUrl" alt="">
        </div>
        </div>
    </div>
  <span slot="footer" class="dialog-footer">
    
  </span>
</el-dialog>
  </div>
</template>

<script>
import { getNews } from "../api/re.js";
export default {
  data() {
    return {
      pageTitle: "集团新闻",
      active_data: [],
      imageFiles: "",
      news:[
        {
            "id": "tw_1608614",
            "title": "极薄罩面预防性养护技术在京昆高速首次应用成功",
            "newsTime": "2021-11-25 00:00:00",
            "source": "首发新闻",
            "content": "近日，养护公司在京昆高速路面养护专项工程中首次应用极薄罩面预防性养护技术，使得路面抗滑性能提升10%，施工周期缩短60%。极薄罩面预防性养护技术，具有快速施工和开放交通，提高行车安全性和舒适性的特点，极大地改善路面抗滑性和平整度，同时还具有降低路面全寿命周期成本和节能环保的特点。其罩面厚度为1.5-2.0cm，混合料沥青采用复配改性技术，既可直接添加在沥青中通过搅拌进行使用，也可直接添加在拌合站的拌缸中使用。防水粘结层采用经复配的改性乳化沥青新材料，以提供超强的粘结力，有效避免磨耗层脱落，使用同步摊铺机进行施工，既避免了对防水粘结层的破坏，又进一步提升了防水能力。过去传统路面养护通常采用普通罩面技术，容易造成施工作业面大、影响社会车辆通行、使用成本较高、与原路面粘结能力降低等问题，改用极薄罩面预防性养护施工后，现场施工人员仅需使用专用摊铺设备将热沥青混合料摊铺在高粘改性乳化沥青粘层上，即喷洒乳化沥青粘层与热沥青混合料摊铺同步进行，时间差约2-4秒，经钢轮压路机压实后一次成型。通过实施极薄罩面养护措施，有效提升了道路通行水平，施工效率可达到每天1000多米，是之前的2倍，极大提升养护经济效益。今后，养护公司将持续开展对预防性养护技术的研究与应用，为“十四五”期间养护专项工程的实施奠定坚实基础。",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=e4bcae32-7f3a-4e10-845e-45894945f3ec",
            "describe": null,
            "images": null
        },
        {
            "id": "tw_1587659",
            "title": "党的十九大代表方秋子列席党的十九届六中全会",
            "newsTime": "2021-11-24 00:00:00",
            "source": "首发新闻",
            "content": "2021年11月8日至11日，党的十九届六中全会顺利召开，京沈分公司“秋子服务”品牌带头人方秋子同志以党的十九大基层代表身份列席了党的十九届六中全会。会后，方秋子同志围绕“学习贯彻党的十九届六中全会精神”在京沈分公司作主题宣讲，分享了列席全会的见闻体会：全会组织筹备工作细致严谨，各项防疫措施落实有力，处处体现着“简朴、节约、安全、高效”的办会原则；全会现场庄重肃穆，秩序井然，与会代表正襟危坐、聚精会神聆听习近平总书记讲话；全会分团讨论环节气氛热烈，中央领导同志深入各小组听取意见建议，与大家一同交流探讨。方秋子同志围绕学习领会全会精神及走好新时代赶考之路两个方面表达了今后的努力方向。她表示，作为党的十九大基层代表、新时代的“交通人”，自己深感责任重大、使命光荣。今后工作中，自己将充分发挥示范引领作用，坚持以学为先，把党的声音传播到“更深处”；坚持扎根一线，把工作责任落实到“更实处”；坚持热心公益，把社会责任投身到“更广处”；坚持强化作风，把自身建设贯彻到“更严处”。继续追求“为交通服务”代言的志向，践行“为人民服务”的诺言，在企业改革发展的浪潮中展现自己应有的责任与担当。",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=dcca55b3-ba77-44e6-8589-07280760fcb9",
            "describe": null,
            "images": null
        },
        {
            "id": "tw_1571684",
            "title": "助力冬奥  |  阪泉综合服务中心圆满完成雪橇世界杯保障任务",
            "newsTime": "2021-11-23 00:00:00",
            "source": "首发新闻",
            "content": "11月22日零时，阪泉服务区正式恢复向社会开通。在为期3天的雪橇世界杯比赛期间，阪泉综合服务中心作为非竞赛场馆，承担了竞赛组织团队、车橇业务领域工作人员、计时记分团队、运动员、教练、观众的安检、测温、换乘工作。期间，共服务3620余人次，340辆车次，其中，外国运动员270人次/天，测试观众300人。阪泉综合服务中心冬奥保障工作专班牢记国企职责与使命，高度重视、周密部署、恪尽职守，圆满完成了雪橇世界杯保障任务。一是结合此次世界杯比赛级别高、境外人员多、增设首批观众等特点，保障专班提前预判，全力做好世界杯保障前期准备工作，做到保障团队力量到位、功能区域划分到位、物资储备到位、设备巡检到位、沟通协调到位、操作培训到位，确保各项保障工作顺利开展。二是严格防疫要求，每日对场馆永、临设施设备进行两次全面预防性消杀；每日组织高风险区域保障人员进行核酸检测及健康监测；高、低风险人员实行分流线管理，集中住宿、点对点交通，避免人员交叉。三是做好服务区环境卫生与废弃物处理，对重点管控生活垃圾进行消毒及封箱转运共73箱。四是增加设备设施的巡检频次，确保设备设施正常运行。每日开展两次全方位巡视检查，对阪泉综合服务中心水泵房、地缘泵房空调系统、净水处理系统、消防供水系统、配电室等设备设施，全面排查事故隐患和安全风险。五是全力组织、快速处理，做好大风天气应急保障。11月21日，阪泉阵风最高达到8级，保障专班快速对通道护栏进行加固和合理拆卸，确保赛事安检顺利进行，得到了阪泉服务中心安保团队高度肯定和赞扬。雪橇世界杯是延庆赛区在北京冬奥会开幕前的最后一次测试赛，阪泉服务中心保障专班将进一步总结宝贵经验，查找不足，为全力做好冬奥保障打下坚实基础。",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=dca0a93e-3a22-427d-a815-e08155f20d38",
            "describe": null,
            "images": null
        },
        {
            "id": "tw_1571685",
            "title": "集团公司副总经理刘绍民到京开分公司调研“中心运行管理模式”推进情况",
            "newsTime": "2021-11-23 00:00:00",
            "source": "首发新闻",
            "content": "11月23日，集团公司副总经理刘绍民到京开分公司就中心试点运行情况进行调研，集团公司高速公路运营管理部部长孔祥杰、副部长付边疆陪同，京开分公司班子成员、相关部门负责人参加会议。会上，分公司从中心试点推进落实、难点与不足、下阶段计划等情况进行汇报。三个收费中心分别从制度建设、业务梳理、区域化管理、业务报表体系建设等角度进行了详细说明。听取汇报后，孔部长对中心运行模式推广情况表示肯定并提出要求，一是要继续深化试点建设，立足实际，探索创新，持续优化运行模式；二是要处理好预算同发展的关系，从成本核算控制入手，探索新途径，实现经济效益和管理效益双提升；三是要关注人员队伍建设等问题，总结凝练管理经验，推进综合管理智能化、智慧化进程，为实现集团公司高质量发展提供有力支撑。刘总指出，中心试点推广是2021年运营管理模式探索迈出的一大步，是为适应新形势、新发展做出的新转变，经过半年多的努力，中心运行模式取得了积极的效果。在谈到下一阶段工作时，刘总强调，要不断深化认识，认清当前行业面临的形势，围绕高速公路网络化、高效化、示范化深入研究，寻找可行性措施，加快推进落实，着力提升整体运行水平及综合竞争实力；要不断深化实践，把握中心运行过程中的关键环节、关键步骤，扬长避短，发扬优势，突破难点，保证下一步工作有方向、有推进、有措施、有落实、有结果；要不断深化总结，凝练中心运行过程中的优秀做法，总结建立中心运行的保障机制，优而化之，推而广之，为中心模式全面铺开打下坚实基础。",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=91b2278b-69d4-48b2-ad85-990f1fe03d04",
            "describe": null,
            "images": null
        },
        {
            "id": "tw_1571666",
            "title": "冬奥快讯 | 49天！八达岭分公司圆满完成现阶段冬奥测试赛保障",
            "newsTime": "2021-11-23 00:00:00",
            "source": "首发新闻",
            "content": "11月22日，随着“相约北京”系列冬季体育赛事正式落下帷幕，八达岭分公司为期49天的通行保障工作也圆满完成。49个日夜，我们凝心聚力，全力以赴，13607批次的保障，16834辆次的赛事车辆顺利通行，是我们交出的满意答卷。1.持续发挥指挥系统作用通过组建冬奥会保障专班，分周、分阶段组织召开主题部署会议，建立总结研判机制，对阶段性保障工作进行梳理总结和研判部署，建立“保障核心区域指挥部”和“保障指挥室”，接入数字视频监控系统信号，强化区域性应急指挥和信息共享，形成强有力的保障指挥体系。2.持续发挥区域联动作用与延庆赛区场馆交通团队、赛事车辆核心保障团队建立联动机制，尽最大可能掌握车辆通行信息和运行情况。与工贸、养护、路产等集团内部兄弟单位建立区域合作机制，全力配合延庆阪泉综合服务中心开展工作，定期参加工作例会并做好信息对接，同步做好阪泉服务区封闭期间的外围保障和现场应对。3.持续强化各项保障措施调配骨干人员专人盯守专道，确保人员固化、业务流程固化、通行习惯固化，为正赛保障积累经验。施行24小时两级监测，掌握重点区域交通状态及特征，加强对人员在岗状态、服务水平的管控；加密隧道设备运维力度和隧道运行监测，强化隧道应急处置和省界隧道群管控，确保隧道安全平稳运行。4.持续做好疫情防控坚持零接触的原则，在海坨、辛家堡、阪泉站区配置扩音器，赛事车辆出现特情时利用扩音器进行现场沟通，特殊情况坚持后台处置。强化员工个人防护，为重点站口员工配发N95口罩提升防护等级，在重点收费站区配备防疫物资消毒柜，装配医用一次性防护服、红外额温枪等防护消杀应急物资。八达岭分公司将及时总结保障经验，持续完善保障方案，为圆满完成2022冬奥会、冬残奥会通行保障工作积蓄力量。",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=87af3932-a799-4130-a2ba-113cbf228221",
            "describe": null,
            "images": null
        },
        {
            "id": "tw_1549243",
            "title": "集团公司在“第三十五届北京市企业管理现代化创新成果”评审中取得佳绩",
            "newsTime": "2021-11-22 00:00:00",
            "source": "首发新闻",
            "content": "近日，在北京市企业管理现代化创新成果审定委员会发布的第三十五届北京市企业管理现代化创新成果名单中，集团公司共有20项成果被审定为“第三十五届北京市企业管理现代化创新成果”本次获奖的20项创新成果，集中体现了集团公司在党建管理、国企改革、运营服务、人力资源等多个方面的最新实践成果，具有良好的发展前景和显著的经济效益、社会效益和生态效益，为集团在新常态下的创新发展实践及深化国企改革、提升发展质量、优化产业结构等方面提供了有益探索和成功经验。同时，此次获奖对进一步激励集团全体员工立足新发展阶段，全面贯彻新发展理念，增强企业活力和创造力，激活企业管理效能，提升经济效益，推动企业高质量发展具有重要意义。",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=0aa3ac5f-a84e-4481-98bb-2099b92626c0",
            "describe": null,
            "images": null
        },
        {
            "id": "tw_1558332",
            "title": "东六环西线隧道进尺创单月新纪录 总掘进里程突破1500米",
            "newsTime": "2021-11-22 00:00:00",
            "source": "首发新闻",
            "content": "掘进在隧道掘进过程中，首发建设公司东六环项目管理处提前策划、精密部署，制定了安全科学的专项施工方案，坚持“稳产即高产”的理念，合理统筹安排工期，在确保安全生产和工程质量的基础上，高度重视人与盾构机、地质与盾构机之间的磨合，逐步探索出合适的掘进参数，提高设备的使用熟练度，并对设备进行局部改造，为后期隧道稳定掘进奠定了基础。目前，“京华号”盾构机已安全平稳掘进1500米，几乎无扰动成功穿越多个风险源，为完成年度工程建设任务打下了坚实的基础。",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=a0ca7cd1-700a-4cb8-8f51-feb620c60f13",
            "describe": null,
            "images": null
        },
        {
            "id": "tw_1549244",
            "title": "集团党委理论中心组专题学习党的十九届六中全会精神",
            "newsTime": "2021-11-22 00:00:00",
            "source": "首发新闻",
            "content": "11月19日上午，集团党委召开理论学习中心组（扩大）学习会议，专题学习党的十九届六中全会精神。会议由党委书记、董事长张闽主持，集团党委理论中心组成员，总部各部室负责人参加学习。围绕学习好、贯彻好、落实好党的十九届六中全会精神,张闽书记强调：一是要全面系统深刻领会六中全会的重大意义，充分认识六中全会的重要地位和深远影响，坚决把思想和行动统一到全会精神和重大决策部署上来；二是要全面系统理解把握六中全会的丰富内涵，深刻领会全会对国有经济国有企业的部署要求，深化改革创新，转换发展动能，提升核心竞争力，夯实高质量发展基础，进一步在服务首都经济社会发展中，发挥好国企骨干作用；三是要全面系统抓紧抓好全会精神的贯彻落实，把深入学习贯彻习近平总书记重要讲话和全会精神，作为当前和今后一个时期的重大政治任务，切实推动全会精神在集团一贯到底。下一步，集团党委将深入开展十九届六中全会精神的学习宣传贯彻，把学习贯彻全会精神与深化拓展党史学习教育紧密结合起来，与加快推进“我为群众办实事”实践活动紧密结合起来，与推进国企改革三年行动紧密结合起来，与做好当前各项工作紧密结合起来，奋力推动集团公司改革发展和党的建设取得新成效，以优异成绩迎接党的二十大召开。",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=3c8dcf51-2251-48a4-9ff4-f78c25acb680",
            "describe": null,
            "images": null
        },
        {
            "id": "tw_1542046",
            "title": "集团公司副总经理郭长宝带队到北京静态交通公司调研指导工作",
            "newsTime": "2021-11-22 00:00:00",
            "source": "首发新闻",
            "content": "<p>11月19日，集团公司副总经理郭长宝带队到北京静态交通公司调研指导工作。集团公司人力资源部部长王京竹，副部长路建、吕欧陪同。北京静态交通公司党委书记、总经理张必民，财务总监王刚及相关人员参加。</p><p>此次座谈围绕人力资源专项工作、“十四五”人才发展规划、落实国企改革三年行动方案以及经理层成员任期制和契约化管理等工作展开。北京静态交通公司<span style='text-indent: 2em;'>财务总监王刚对公司基本情况、人力资源专项工作、经理层任期制及契约化改革进展进行汇报，并结合公司发展，阐述公司“十四五”人才发展规划思路。北京静态交通公司</span><span style='text-indent: 2em;'>党委书记、总经理张必民结合公司经营发展情况，就人力资源工作如何融入集团公司发展进行阐述。</span></p><p>郭长宝副总经理对公司近年发展给予肯定，并强调：一是要进一步明确经理层任期制及契约化改革核心，合理制定考核指标，确保年底前顺利完成；二是要着手启动“三项制度”改革，加大市场化选聘力度；三是要系统深化研究纳入集团体系后的业绩考核工作，确保考核体系符合集团发展要求；四是要着力做好三支队伍人才建设，不断细化人力资源规划，为公司持续良好发展打下坚实基础。</p>",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=2951069f-4a05-4a7f-b356-26dbb40fe010",
            "describe": null,
            "images": null
        },
        {
            "id": "tw_1520681",
            "title": "跑秒计时 压线冲刺 全力推进冬奥标线施划",
            "newsTime": "2021-11-19 00:00:00",
            "source": "首发新闻",
            "content": "<p style='text-indent: 0em;'><img title='5.jpg' alt='5.jpg' src='https://www.bchd.com.cn:8088/upload/image/20211117/6377276787200005318331577.jpg'/><br/></p><p>当前，2022年冬奥会筹办工作已进入决战决胜的冲刺阶段，作为北京市交通委、北京市交管局冬奥会专用车道工程的中标单位，北京首发公路养护工程有限公司以跑秒计时的状态、压线冲刺的干劲，全力以赴抓好专用车道标线施划各项工作，以实干展现首发风貌、首发担当、首发智慧和首发力量。</p><p>履行责任显担当。作为具体实施单位，养护公司成立专项工作组，实行管理人员片区责任制、一对一现场盯守，全力统筹好疫情常态化防控和工程施工，强化安全、质量、进度管控，确保工程优质履约。工作组多次现场踏勘，详细记录标线工程量以及难点、重点，制定了详细的工作任务清单，强化施工质量和工程应急保障能力。通过对现场路段的分析评估，制定切实可行的交通导行方案，最大限度的减少对社会车辆通行的影响，展现国企担当。</p><p>科技创新提质效。由于传统标志标线材质及施工工艺对地面温度有严苛要求，当地面温度低于5摄氏度时，将直接影响标志标线的粘结牢固性和使用寿命。为解决冬季施工中的不利影响，养护公司对传统标识标贴材料和施工工艺进行改进创新，使用新型橡胶材质的预成型标贴，并采用“镂空填补法”施工，让整个标志处于同一平面上。同时从地面加热和保温设施方面入手，确保低温条件下的作业质量。引进标志标牌数码打印设备，实现制作过程机械化、数字化，使标志更加清晰立体，并具有反光系数一致、板面平整精细等特点，以科技创质创安创效。</p><p>此次中标的冬奥会专用车道工程，涉及城市道路及部分高速公路，包括交管局负责实施的冬奥、冬残奥专用道、优先路等40余条道路，共计74.7公里，以及交通委负责实施的机场高速、六环路两条高速公路，共计99.2公里。目前，城市道路方面已于11月12日正式开工，计划11月底前完成20条专用道标线、冬奥、冬残奥标识粘贴、标志基础设置工作。高速公路部分已于11月18日正式开工，道路专用车道部分计划在11月底前完工，指示牌部分计划在12月底前完工。</p><p>同心筑梦，厉兵秣马，全体首都养路人将认真贯彻新发展理念，坚定信心、奋发作为、精益求精、战胜困难，为冬奥盛会做出首发贡献！</p><p><br/></p>",
            "update_time": null,
            "url": "https://www.bchd.com.cn:8080/information/getInformation?infoId=af685b6d-ca32-4102-996b-fb16201537fe",
            "describe": null,
            "images": null
        }
    ],
      hover: null,
      update_data: null,
      showBody: "",
      show: false,
       list:{},
    dialogVisible: false,
    imgs:[]
    };
  },
  filters: {
    temp_filter(value) {
      if (value) {
        return value;
      } else {
        return "";
      }
    },
  },
  created() {
    if (this.$route.query.innerTitle) {
      this.pageTitle = this.$route.query.innerTitle;
    }
    //接口
    this.lond();
  },
  mounted() {
    this.pageInit();
         if (location.href.indexOf("#reloaded") == -1) {
                location.href = location.href + "#reloaded";
           location.reload();        
    }
  },

  beforeDestroy() {
    this.stopScroll(true);
  },
  methods: {
    pageInit() {
      // this.getNews(); // 首次加载数据
      this.update_data = setInterval(() => {
        // this.getNews();
      }, 1000 * 60 * 10); // 数据刷新周期十分钟
    },
       handleClose(done) {
         this.imgs=[];
       this.dialogVisible=false
      },
     goind(item,text,CONTENT){
       this.dialogVisible=true
      this.list=item 
        var data1=item.images
 var demArray1 =[];
var demArray1 = data1.map(item => {
     return {
        imgUrl: item
        }
      })
     this.imgs=demArray1
   console.log(this.imgs, "获取到的图片");
    },
     goindr(url) {
      window.open(url);
    },
    showDialog(v) {
      this.showBody = v;
      this.show = true;
      this.stopScroll();
    },
    closeDialog() {
      if (!this.show) {
        return;
      }
      this.show = false;
      var eventBtn = document.getElementById("eventBtn");
      if (eventBtn.className == "stop") {
        this.startScroll();
      }
      setTimeout(() => {
        this.showBody = "";
      }, 1200);
    },
    startScroll() {
      this.stopScroll();
      this.hover = setInterval(() => {
        // 最后一个元素前置
        let a = document.getElementsByClassName("newslist");
        let el = a[a.length - 1];
        // el.remove()
        document.getElementById("news").prepend(el);
    
        // 保存高亮项信息到localStorage
        let active_el = a[4];
        let active_item = this.active_data.filter(
          (k) => k.index == active_el.dataset.index
        )[0];
        // this.setStorage(active_item);
      }, 5000);
    },
    stopScroll() {
      clearInterval(this.hover);
      clearInterval(this.update_data);
      // clearDataUpdate && clearInterval(this.update_data);
    },
    setStorage(item) {
      // window.localStorage.setItem("topic_name", item.topic_name);
      console.log(11111,'付远航')
      // window.localStorage.setItem("topic_id", item.topic_id);
      // window.localStorage.setItem("topic_info", item.topic_info);
    },
    //获取数据
    lond() {
      getNews().then((res) => {
          // let news=this.news
        let news = res.data.data;
        // console.log(news,"jjjjjj");
        while (news.length < 9) {
          news = news.concat(news);
        }
        this.active_data = [];
        if (this.hover) {
          this.stopScroll();
        }
        // 依次放入&展示
        for (let i = 0; i < 9; i++) {
          setTimeout(() => {
            this.active_data.push(news[i]);
          }, i * 500);
        }
        // 延时展示后开始滚动
        setTimeout(() => {
          this.startScroll();
        }, news.length * 500);
      });
    },
    //暂停播放键
    pauseOrPlay() {
      var eventBtn = document.getElementById("eventBtn");
      if (eventBtn.className == "stop") {
        eventBtn.removeAttribute("stop");
        eventBtn.setAttribute("class", "play");
        this.stopScroll();
      } else {
        eventBtn.removeAttribute("play");
        eventBtn.setAttribute("class", "stop");
        this.startScroll();
      }
    },
    //改变日期格式
    getDate() {
      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      var day =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      var dateStr = year + "" + month + "" + day;
      return dateStr;
    },
  },
};
</script>
<style>
.time_img{
  width: 100%;
  height: 5vh;
  display: flex;
 /* justify-content: space-around; */
  align-items: center;
  flex-wrap: wrap;
}
.wx_img{
padding: 10px;
}
.img_wx{
  width:170px;
  height: 140px;
}


</style>
<style scoped lang="scss">
.body_tiele {
  font-size: 30px;
  font-family: PingFang;
  font-weight: bold;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
}
.body_img {
  position: relative;
  left: 5px;
  cursor: pointer;
}
.live {
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #60d6dd;
}
.body_cont {
  width: 90%;
  height: 60vh;
  overflow-y: scroll;
  margin: 0 auto;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 28px;
  color: #ffffff;
}
.specialAttention {
  background-image: url("../assets/Starting/img-groupNews/expert_bg_img.jpg");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: relative;
  .head {
    margin: 0 3vw;
    display: flex;
    align-items: center;
    height: 12vh;
    justify-content: space-between;
    user-select: none;
    position: relative;
    .bodyTitle {
      height: 7.4vh;
      font-size: 1.4vw;
      font-weight: bold;
      color: #fff;
      display: flex;
      align-items: center;
      margin-left: 6vw;
      img {
        width: 6vw;
      }
      .img_monitor {
        transform: rotate(180deg);
      }
      .pageTitle {
        margin: 0 0.5em;
        white-space: nowrap;
      }
    }
  }
  .main {
    width: 100%;
    height: calc(100% - 12vh);
    position: relative;
    .cilre {
      position: absolute;
      width: 25vw;
      height: 70vh;
      border-radius: 50%;
      border-right: 1px solid #04def7;
      left: -11%;
      top: 5vh;
      .eventBtn {
        position: absolute;
        top: calc(50% - 40px);
        right: 8%;
        padding: 20px;
        border-radius: 50%;
        background-color: rgba(23, 29, 66, 0.6);
        cursor: pointer;
        div.stop {
          background-image: url("../assets/Starting/img-groupNews/stop.png");
        }
        div.play {
          background-image: url("../assets/Starting/img-groupNews/play.png");
        }
        div {
          width: 40px;
          height: 40px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
    .cilre:before {
      content: "";
      position: absolute;
      width: 50%;
      height: 45vh;
      border-radius: 50%;
      border-right: 1px solid #04def7;
      left: 24.5%;
      top: 60%;
      margin-top: -29vh;
      opacity: 0.5;
    }
    //右边
    .newslist {
      position: absolute;
      top: -500px;
      left: 0;
      opacity: 0;
      cursor: pointer;
      height: 8vh;
      line-height: 4.6vh;
      color: #fff;
      padding: 1.8vh 1.5% 1.8vh 3%;
      width: 86%;
      transition: all 0.6s;
      img {
        width: 0;
      }
      .info {
        color: #00ccff;
        text-align: right;
        white-space: nowrap;
        font-style: normal;
        font-size: 1.2vw;
        margin-right: 9%;
      }
      .news-box {
      
        &:after {
          content: "";
          clear: both;
          display: block;
          height: 0;
          overflow: hidden;
        }
      }
      &:before {
        content: "";
        display: block;
        position: absolute;
        left: 0.5%;
        top: 50%;
        width: 2%;
        height: 4vh;
        background: url("../assets/Starting/img-groupNews/dian.png") no-repeat center
          center;
        background-size: contain;
        border-radius: 50%;
        transform: translate(0, -50%);
      }
    }
    .newslist:nth-child(1) {
      position: absolute;
      top: 2.4vh;
      left: 9.2%;
      opacity: 0.2;
      transform: translate(-6.5%, 0);
      font-size: 1.2vw;
      .news-box {
        opacity: 0.4;
      }
    }
    .newslist:nth-child(2) {
      position: absolute;
      top: 7vh;
      left: 12.8%;
      opacity: 0.6;
      transform: translate(-6.5%, 0);
      font-size: 1.4vw;
      .news-box {
        opacity: 0.6;
      }
    }
    .newslist:nth-child(3) {
      position: absolute;
      top: 14.2vh;
      left: 15.6%;
      opacity: 0.8;
      transform: translate(-6.5%, 0);
      font-size: 1.6vw;
      .news-box {
        opacity: 0.8;
      }
    }
    .newslist:nth-child(4) {
      position: absolute;
      top: 23.1vh;
      left: 17.5%;
      opacity: 0.9;
      transform: translate(-6.5%, 0);
      font-size: 1.8vw;
      .news-box {
        opacity: 0.9;
      }
    }
    .newslist:nth-child(5) {
      position: absolute;
      top: 30vh;
      left: 18.2%;
      opacity: 1;
      transform: translate(-6.5%, 0);
      font-size: 2vw;
      color: #f5c512;
      height: 22.6vh;
      .news-box {
        opacity: 1;
        padding: 0.8vh 1.3% 1.5vh;
        background: url("../assets/Starting/img-groupNews/libg.png") no-repeat;
        background-size: 100% 100%;
        height: calc(100% - 4vh);
        overflow: hidden;
      }
      .textp {
        display: block;
        width: 80vw;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .info {
        margin-right: 8%;
      }
    }
    .newslist:nth-child(5):before {
      background: url("../assets/Starting/img-groupNews/dian1.png") no-repeat center
        center;
      background-size: contain;
    }
    .newslist:nth-child(6) {
      position: absolute;
      top: 48vh;
      left: 17.5%;
      opacity: 0.9;
      transform: translate(-6.5%, 0);
      font-size: 1.8vw;
      .news-box {
        opacity: 0.9;
      }
    }
    .newslist:nth-child(7) {
      position: absolute;
      top: 57vh;
      left: 15.8%;
      opacity: 0.8;
      transform: translate(-6.5%, 0);
      font-size: 1.6vw;
      .news-box {
        opacity: 0.8;
      }
    }
    .newslist:nth-child(8) {
      position: absolute;
      top: 64.8vh;
      left: 12.9%;
      opacity: 0.6;
      transform: translate(-6.5%, 0);
      font-size: 1.4vw;
      .news-box {
        opacity: 0.6;
      }
    }
    .newslist:nth-child(9) {
      position: absolute;
      top: 70vh;
      left: 8.8%;
      opacity: 0.4;
      transform: translate(-6.5%, 0);
      font-size: 1.2vw;
      .news-box {
        opacity: 0.4;
      }
    }
    .newslist:nth-child(1):before,
    .newslist:nth-child(9):before {
      background-size: 70% 70%;
    }
    .newslist:nth-child(2):before,
    .newslist:nth-child(8):before {
      background-size: 80% 80%;
    }
    .newslist:nth-child(3):before,
    .newslist:nth-child(7):before {
      background-size: 90% 90%;
    }
    .r {
      float: right;
      margin-right: 4%;
    }
    h5 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .textp {
      display: none;
      width: 80vw;
      height: 6.4vh;
      font-size: 1.3vw;
      line-height: 1.2;
      color: #e9e9e9;
      margin-top: 5px;
    }
    .hidden-item {
      opacity: 0;
      filter: Alpha(opacity=0);
      z-index: -1;
    }
  }
}
</style>
